import React from "react";
import ClientTypeSection from "./clientType/ClientTypeSection";
import CompanySizeSection from "./companySize/CompanySizeSection";
import AbsenceThresholdSection from "./absenceThreshold/AbsenceThresholdSection";
import PaymentTermsSection from "./paymentTerms/PaymentTermsSection";

const ClientConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <ClientTypeSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <CompanySizeSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <AbsenceThresholdSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <PaymentTermsSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default ClientConfigSection;
